import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, CodedProperty, ButtonRenderProps } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../../common/types/Language";
import {
    EditOnPremAudioAssetButtonAside,
    EditOnPremAudioAssetButtonAsideProps
} from "./edit/EditOnPremAudioAssetButtonAside";
interface OnPremAudioLanguageSectionProps {
    isLoading: boolean;
    language: CodedProperty;
}

export const OnPremAudioLanguagesSection = (props: OnPremAudioLanguageSectionProps): JSX.Element => {
    const { isLoading, language } = props;

    const editSoundtrackButton: ButtonRenderProps<EditOnPremAudioAssetButtonAsideProps> = {
        isLabeled: true,
        render: EditOnPremAudioAssetButtonAside,
        soundtrackId: language.id
    };

    return (
        <ContentSection header="Languages" isLoading={isLoading} buttons={[editSoundtrackButton]}>
            <GridRow style={{ height: 200 }}>
                <GridColumn sm={12}>
                    <LabeledText
                        label="Soundtracks"
                        value={getLanguageDisplayName(language)}
                        testId="soundtracks-field"
                    />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
